import React from 'react';

const path = process.env.PUBLIC_URL

const Summary = () => {
  return (
    <div className="intro__container">
      <h2><span>卷后总结</span></h2>
      <div className="intro">
        <div className="intro__text">
        以上试题来自《乐队的夏天》和《乘风破浪的姐姐》两个热播音乐综艺。歪脑分析了两个音综七季节目中演出的全部歌曲共475首歌曲，统计出126处歌词在播出时被改动的实例。<br/>歪脑综合参考了《电视剧内容制作通则》和网易盾的网络敏感词分类，对被改动的歌词进行了归纳分类。
        </div>
      </div>
      <img src={`${path}/images/start.svg`} className="absolute w-[60px] top-[35px] right-[5px] z-10" />
      <img src={`${path}/images/eye.svg`} className="absolute w-[100px] bottom-[10px] left-[50%] z-0 translate-x-[-50%]" />
    </div>
  );
};

export default Summary;